import { createBrowserHistory } from 'history';
import type { IFormPathWithSearchParams } from '../utils/formPathWithSearchParams';
import formPathWithSearchParams from '../utils/formPathWithSearchParams';
import { PUBLIC_URL } from '../config';

const appHistory = createBrowserHistory({ basename: PUBLIC_URL });

export const appHistoryPushWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = ''): void => {
    appHistory.push(formPathWithSearchParams(params, pathname));
};

export const appHistoryReplaceWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = ''): void => {
    appHistory.replace(formPathWithSearchParams(params, pathname));
};

export const isExistSearchParam = (key: string, value: string): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.getAll(key).includes(value);
};

export const excludeSearchParam = (key: string, value: string | string[], search?: URLSearchParams): URLSearchParams => {
    const urlParams = search || new URLSearchParams(window.location.search);
    const values = urlParams.getAll(key);
    const valueToExude = value instanceof Array ? value : [value];
    const filtered = values.filter(function (el) {
        return !valueToExude.includes(el);
    });
    urlParams.delete(key);
    filtered.forEach((item) => {
        urlParams.append(key, item);
    });
    return urlParams;
};

export const excludeSearchParams = (params: { [key: string]:  string | string[] }): URLSearchParams => {
    let urlParams = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([key, value]) => {
        urlParams = excludeSearchParam(key, value, urlParams);
    });
    return urlParams;
}

export const urlSearchToHistoryString = (urlParams: URLSearchParams) =>
    `${appHistory.location.pathname}?${urlParams.toString()}`;



export default appHistory;
